import { getDecisionValue } from '../plans/applyPatch.js';
export const ACTION_VALUE_SOURCES = [
    'user_decision',
    'project_fact',
    'ai_suggestion',
    'system_default',
];
export function isConfirmedDecision(known, key) {
    return known.decisions.some((d) => d.key === key && d.confirmed);
}
export function sourceForPlanField(known, key, hasStructuredValue, fallback = 'system_default') {
    if (isConfirmedDecision(known, key))
        return 'user_decision';
    if (getDecisionValue(known, key) !== undefined)
        return 'user_decision';
    if (hasStructuredValue)
        return 'project_fact';
    return fallback;
}
//# sourceMappingURL=provenance.js.map